import axios from 'axios';
import config from '../config';

export const verifyIfUserExists = (username) =>
  axios.request({
    method: 'get',
    url: `${config.providerApiInternal}/users/existLogin?login=${username}`,
  });



// WEBPACK FOOTER //
// ./src/api/users.js